<div>
  <div class="breadcrumbs">
    <button class="back-button" (click)="onCancel()">
      <mat-icon>arrow_back_ios</mat-icon>
      <span class="breadcrumb-text">{{ this.corpAdminConstants.breadCrumbHome }}</span>
    </button>
    <div class="slash">/</div>
    @if (!isEditMode) {
      <span class="breadcrumb-text">{{ this.corpAdminConstants.breadCrumbNewTask }}</span>
    }
    @if (isEditMode) {
      <span class="breadcrumb-text">{{ this.corpAdminConstants.breadCrumbEditTask }}</span>
    }
  </div>

  <content-panel>
    <panel-body>
      <form [formGroup]="taskFormGroup">
        <div class="container-row">
          <div class="container-left">
            <!-- Task Name Section -->
            <div class="task-name">
              <span class="section-title">{{this.corpAdminConstants.taskNameTitle}}</span>
              <div class="edit-task-container">
                <mat-form-field class="task-text-area">
                  <textarea matInput #input placeholder="{{this.corpAdminConstants.taskNamePlaceholder}}"
                  formControlName="taskName" maxlength="350" required></textarea>
                  <mat-hint class="mat-hint">{{taskFormGroup.get('taskName')?.value.length || 0}} / 350</mat-hint>
                </mat-form-field>
                @if (isEditMode) {
                  <div>
                    @if(originalValueCheck(taskFormGroup.get('taskName')?.value)) {
                      <mat-icon class="refresh-icon-disabled">refresh</mat-icon>
                    } @else {
                      <button class="refresh-button" mat-icon-button (click)="resetTaskName()">
                        <mat-icon class="refresh-icon">refresh</mat-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>

            <!-- Required Checkbox Section -->
            <div class="check-box">
              <span class="required-text">{{this.corpAdminConstants.requiredTitle}}</span>
              <mat-checkbox formControlName="required" class="chk-box"></mat-checkbox>
            </div>

            <!-- Category and Code Section -->
            <div class="category-container">
              <div class="titles">
                <span class="category-title">
                  {{this.corpAdminConstants.categoriesTitle}}
                </span>
                <span class="code-title">
                  {{this.corpAdminConstants.codesTitle}}
                </span>
              </div>
              <!-- CCI toggle and code -->
              <div class="code-container">
                <mat-slide-toggle formControlName="cciToggle" color="primary">
                  <span class="toggle-text">{{this.corpAdminConstants.CCItoggle}}</span>
                </mat-slide-toggle>
                <corp-drop-down
                  [dropdownType]="corpAdminConstants.codeDropDown"
                  [dropdownValues]="cciCodes"
                  [alreadyUsedCodes]="alreadyUsedCodes"
                  [categoryControl]="taskFormGroup.get('cciToggle')"
                  [selectedCode]="taskFormGroup.get('cciCode')?.value"
                  (selectionChange)="onCodeChange($event, 'cciCode')">
                </corp-drop-down>
              </div>
              <!-- AOC toggle and code -->
              <div class="code-container">
                <mat-slide-toggle formControlName="aocToggle" color="primary">
                  <span class="toggle-text">{{this.corpAdminConstants.AOCtoggle}}</span>
                </mat-slide-toggle>
                <!-- USE LATER when we have codes -->
                <!-- <corp-drop-down
                [dropdownType]="corpAdminConstants.codeDropDown"
                [categoryControl]="taskFormGroup.get('aocToggle')"
                [selectedCode]="taskFormGroup.get('aocCode')?.value"
                (selectionChange)="onCodeChange($event, 'aocCode')">
              </corp-drop-down> -->
              <div class="no-code-div"></div>
            </div>
            <!-- CQI toggle and code -->
            <div class="code-container">
              <mat-slide-toggle formControlName="cqiToggle" color="primary">
                <span class="toggle-text">{{this.corpAdminConstants.CQItoggle}}</span>
              </mat-slide-toggle>
              <!-- USE LATER when we have codes -->
              <!-- <corp-drop-down
              [dropdownType]="corpAdminConstants.codeDropDown"
              [categoryControl]="taskFormGroup.get('cqiToggle')"
              [selectedCode]="taskFormGroup.get('cqiCode')?.value"
              (selectionChange)="onCodeChange($event, 'cqiCode')">
            </corp-drop-down> -->
            <div class="no-code-div"></div>
          </div>
          <!-- QSI toggle and code -->
          <div class="code-container">
            <mat-slide-toggle formControlName="qsiToggle" color="primary">
              <span class="toggle-text">{{this.corpAdminConstants.QSItoggle}}</span>
            </mat-slide-toggle>
            <!-- USE LATER when we have codes -->
            <!-- <corp-drop-down
            [dropdownType]="corpAdminConstants.codeDropDown"
            [categoryControl]="taskFormGroup.get('qsiToggle')"
            [selectedCode]="taskFormGroup.get('qsiCode')?.value"
            (selectionChange)="onCodeChange($event, 'qsiCode')">
          </corp-drop-down> -->
          <div class="no-code-div"></div>
        </div>
        <!-- eBuilt toggle and code -->
        <div class="code-container">
          <mat-slide-toggle formControlName="ebuiltToggle" color="primary">
            <span class="toggle-text">{{this.corpAdminConstants.ebuiltToggle}}</span>
          </mat-slide-toggle>
          <!-- USE LATER when we have codes -->
          <!-- <corp-drop-down
          [dropdownType]="corpAdminConstants.codeDropDown"
          [categoryControl]="taskFormGroup.get('ebuiltToggle')"
          [selectedCode]="taskFormGroup.get('ebuiltCode')?.value"
          (selectionChange)="onCodeChange($event, 'ebuiltCode')">
        </corp-drop-down> -->
        <div class="no-code-div"></div>
      </div>
      <!-- eBuilt Plus toggle and code -->
      <div class="code-container">
        <mat-slide-toggle formControlName="ebuiltPlusToggle" color="primary">
          <span class="toggle-text">{{this.corpAdminConstants.ebuiltPlusToggle}}</span>
        </mat-slide-toggle>
        <!-- USE LATER when we have codes -->
        <!-- <corp-drop-down
        [dropdownType]="corpAdminConstants.codeDropDown"
        [categoryControl]="taskFormGroup.get('ebuiltPlusToggle')"
        [selectedCode]="taskFormGroup.get('ebuiltPlusCode')?.value"
        (selectionChange)="onCodeChange($event, 'ebuiltPlusCode')">
      </corp-drop-down> -->
      <div class="no-code-div"></div>
    </div>
  </div>
</div>
<div class="container-right">
  <!-- Drag and Drop Dept Section -->
  <div cdkDropListGroup>
    <span class="section-title">{{this.corpAdminConstants.deptTitle}}</span>
    <div class="drag-drop-row">
      <div class="drag-drop-container">
        <span class="drag-drop-titles">{{this.corpAdminConstants.unassignedTitle}}</span>
        <div
          cdkDropList
          #unassigned="cdkDropList"
          [cdkDropListData]="unassignedList"
          [cdkDropListConnectedTo]="[assigned]"
          class="example-list"
          (cdkDropListDropped)="drop($event)">
          @if(unassignedList.length === 0) {
            <div class="empty-dept-text">{{this.corpAdminConstants.emptyUnassignedDepts}}</div>
            }@else {
            @for (item of unassignedList; track item) {
              <div class="example-box" cdkDrag>{{item.Name}}</div>
            }
          }
        </div>
      </div>

      <div class="drag-drop-container">
        <span class="drag-drop-titles">{{this.corpAdminConstants.assignedTitle}}</span>
        <div
          cdkDropList
          #assigned="cdkDropList"
          [cdkDropListData]="assignedList"
          [cdkDropListConnectedTo]="[unassigned]"
          class="example-list"
          (cdkDropListDropped)="drop($event)">
          @if(assignedList.length === 0) {
            <div class="empty-dept-text">{{this.corpAdminConstants.emptyAssignedDepts}}</div>
            }@else {
            @for (item of assignedList; track item) {
              <div class="example-box" cdkDrag>{{item.Name}}</div>
            }
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Primary Dept Section -->
  <div class="primary-dept-section">
    <span class="primary-title">{{this.corpAdminConstants.primaryDeptTitle}}</span>
    @if(assignedList.length > 0) {
      <mat-form-field class="primary-dept-dropdown">
        <mat-select placeholder="{{this.corpAdminConstants.primaryDeptPlaceholder}}"
          formControlName="primaryDeptId">
          @for (dept of assignedList; track dept) {
            <mat-option [value]="dept.Id">{{ dept.Name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else {
      <mat-form-field class="primary-dept-dropdown">
        <mat-select placeholder="{{this.corpAdminConstants.primaryDeptPlaceholder}}" disabled>
          @for (dept of assignedList; track dept) {
            <mat-option [value]="dept">{{ dept.Name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-icon class="primary-dept-tooltip" [matTooltip]="this.corpAdminConstants.primaryDeptTooltip">info</mat-icon>
  </div>
</div>
</div>
</form>

<!-- save and cancel button -->
<div class="button-row">
  <button mat-button (click)="onCancel()" class="cancel-button">{{this.corpAdminConstants.cancelButton}}</button>
  <button mat-button (click)="onSave(taskFormGroup)" [matTooltip]="!taskFormGroup.valid ? this.corpAdminConstants.disableSaveTooltip : ''"
  [disabled]="!taskFormGroup.valid || !hasFormChanged" class="save-button">{{this.corpAdminConstants.saveButton}}</button>
</div>
</panel-body>
</content-panel>
</div>